import React from "react";
import Avatar from "react-avatar";

const Sidbar = ({ handleUserSelect,selectedUser,users }) => {
  // const users = [
  //   { id: 1, name: "User 1", profilePic: "https://via.placeholder.com/50" },
  //   { id: 2, name: "User 2", profilePic: "https://via.placeholder.com/50" },
  //   { id: 3, name: "User 3", profilePic: "https://via.placeholder.com/50" },
  //   // Add more users as needed
  // ];
  return (
   
          <div className={`col-md-4 col-sm-12 mr-0 pr-0 ${selectedUser ? 'd-none d-md-block' : ''}`}>
        
      {/* <h3>List of Users</h3> */}
      <ul className="list-group">
        {users.map((user) => (
          <li
            key={user.id}
            className={`list-group-item ${
              selectedUser && selectedUser.id === user?.user?.id ? "active" : ""
            }`}
            onClick={() => handleUserSelect(user?.user)}
          >
            <Avatar name={user?.user?.name} size={30} round="50%" />
            <span className="ml-2"> {user?.user?.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidbar;
